module.exports = __webpack_public_path__ + "static/media/mgallerythree.cc9b9cc0.jpg";